import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as BookingService from '_services/booking-service';

const initialState = {
    transactions: null,
    status: 'idle',
    error: null
};

// fetch bookings data
export const getTransactions = createAsyncThunk('bookings/getTransactions', async (uid) => {
    return BookingService.getTransactions(uid);
})


const transactionsSlice = createSlice({
    name: 'transactions',
    initialState,
    reducers: {
        reset: (state) => initialState
    },
    extraReducers: {
        [getTransactions.pending]: (state, action) => {
            return {
              ...state,
              status: 'loading',
            }
        },
        [getTransactions.fulfilled]: (state, action) => {
            return {
              ...state,
              status: 'succeeded',
              transactions: action.payload,
            }
        },
        [getTransactions.rejected]: (state, action) => {
            return {
              ...state,
              status: 'failed',
              error: action.error.message
            }
        },
    }
});

export const { reset } = transactionsSlice.actions;
export const selectTransactions = state => state.transactions.transactions;
export default transactionsSlice.reducer;
